import { create } from 'zustand';
import { parse } from '@libs/utils/json';
import { onboardingItems } from './onboardingItems';

type InitialState = {
  items: typeof onboardingItems;
  showWidget: boolean;
  completedSteps: Record<string, boolean>;
  toggleWidget: (show?: boolean) => void;
  setCompletedStep: (step: string) => void;
};

export const useOnboardingStore = create<InitialState>()((set) => ({
  completedSteps: restoreCompletedSteps(),
  showWidget: localStorage.getItem('hideOnboardingWidget') !== 'true',
  items: onboardingItems,
  toggleWidget: (show) => {
    const showWidget = show ?? localStorage.getItem('hideOnboardingWidget') !== 'true';
    if (showWidget) {
      localStorage.removeItem('hideOnboardingWidget');
      set({ showWidget: true });
      return;
    }
    localStorage.setItem('hideOnboardingWidget', 'true');
    set({ showWidget: false });
  },
  setCompletedStep: (step) => {
    set((state) => {
      const newCompletedSteps = { ...state.completedSteps, [step]: true };
      localStorage.setItem('onboarding.completedSteps', JSON.stringify(newCompletedSteps));
      return {
        completedSteps: newCompletedSteps,
      };
    });
  },
}));

function restoreCompletedSteps(): Record<string, boolean> {
  const savedValue = parse<Record<string, boolean>>(localStorage.getItem('onboarding.completedSteps') || '{}');

  return {
    organization: savedValue['organization'] ?? false,
    branding: savedValue['branding'] ?? false,
    users: savedValue['users'] ?? false,
    clients: savedValue['clients'] ?? false,
    talents: savedValue['talents'] ?? false,
    shifts: savedValue['shifts'] ?? false,
  };
}
